import React, {useCallback, useEffect} from 'react';
import DatePicker from "../../DatePicker/DatePicker";
import DateFilter from "../../../grids/filters/date";
import TextFilter from "../../../grids/filters/text";
import TextCustomFilter from "../../../grids/filters/textCustom";
import SelectFilter from "../../../grids/filters/select";
import NumberFilter from "../../../grids/filters/number";
import {unitName} from "../../../grids/utils";
import BoolFilter from '../../../grids/filters/bool';

const Filter = ({disabled, value, onChange, column, filterParams, isGrid, isDictionary}) => {
    const filterType = (col) => {
        switch (col.filterType) {
            case 'date':
                return <DatePicker
                    disabled={disabled}
                    hideCalendarIcon
                    compact
                    clearable
                    name={column.fieldName}
                    dateFormat='dd.MM.yyyy'
                    placeholderText={column.title}
                    value={value}
                    onChange={(e, {value}) => onChange(column.fieldName, value)}
                    maxDate={filterParams.to}
                    minDate={filterParams.from}
                />
            case 'string':
            case 'text':
                return <input
                    type="text"
                    className="form-control"
                    placeholder={column.title}
                    value={value || ''}
                    onChange={(e) => onChange(column.fieldName, e.target.value)}
                    disabled={disabled}
                />
            case 'number':
                return <input
                    type="number"
                    className="form-control"
                    placeholder={column.title}
                    value={value || ''}
                    onChange={(e) => onChange(column.fieldName, e.target.value)}
                    disabled={disabled}
                />
            case 'dropdown':
            case 'select':
                return <select
                    className="form-control"
                    value={value || ''}
                    onChange={(e) => onChange(column.fieldName, e.target.value)}
                    disabled={disabled}
                >
                    <option value="">{column.title}</option>
                    {(filterParams.options || []).map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            default:
                return <input
                    type="text"
                    className="form-control"
                    placeholder={column.title}
                    value={value || ''}
                    onChange={(e) => onChange(column.fieldName, e.target.value)}
                    disabled={disabled}
                />
        }
    }

    const filterTypeGrid = (col) => {
        switch (col.filterType) {
            case 'date':
                return <DateFilter
                    withSort={!column.disableSort}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'text':
            case 'string':
            case 'multiText':
                return <TextFilter
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'textCustom':
                return <TextCustomFilter
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'number':
                return <TextFilter
                    type='number'
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'select':
            case 'dropdown':
                return <SelectFilter
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                    isDictionary={isDictionary}
                />
            case 'selectMultiple':
                return <SelectFilter
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                    multiple
                    isDictionary={isDictionary}
                />
            case 'status':
                return <SelectFilter
                    filterParams={filterParams}
                    isStatus
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'numberRange':
                return <NumberFilter
                    unit={unitName(column.fieldName)}
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            case 'bool':
                return <BoolFilter
                    filterParams={filterParams}
                    column={column}
                    filter={value}
                    setFilter={f => onChange(f)}
                />
            default:
                return null
        }
    }

    return (
        isGrid
            ? <div className='grid-filter field filter-input ultra-compact'>
                {filterTypeGrid(column)}
                <div className='sizer'>{column.title}</div>
            </div>
            : filterType(column)
    );
};

export default Filter;


// WEBPACK FOOTER //
// ./App/components/Table/components/Filter.jsx